// NOTE: This should be kept in sync with back-end api/external/permissions.json and api/external/permission.rb
export enum ApiPermission {
  AccountRead = 'account.read',
  AccountWrite = 'account.write',
  ApiKeyRead = 'api_key.read',
  ApiKeyScim = 'api_key.scim',
  ApiKeyWrite = 'api_key.write',
  ApiLogRead = 'api_log.read',
  CaseRead = 'case.read',
  CaseWrite = 'case.write',
  DocumentRead = 'document.read',
  DocumentWrite = 'document.write',
  EventRead = 'event.read',
  GraphRead = 'graph.read',
  GraphWrite = 'graph.write',
  ImporterRead = 'importer.read',
  ImporterWrite = 'importer.write',
  InquiryRead = 'inquiry.read',
  InquiryWrite = 'inquiry.write',
  ListRead = 'list.read',
  ListWrite = 'list.write',
  ReportRead = 'report.read',
  ReportWrite = 'report.write',
  TxnRead = 'txn.read',
  TxnWrite = 'txn.write',
  UserAuditLogRead = 'user_audit_log.read',
  VerificationRead = 'verification.read',
  VerificationWrite = 'verification.write',
  WebhookRead = 'webhook.read',
  WebhookWrite = 'webhook.write',
  WorkflowTrigger = 'workflow.trigger',
}
